import React from 'react'
import './footer.css'
import {FaTwitter} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <h1 className='footer__logo'>GX Budz</h1>

      <div className="footer__socials">
        <a href="https://twitter.com/GXBudz" className="twitter__logo" target='_blank' rel="noreferrer"><FaTwitter/></a>
      </div>

      <div className="footer__copyright">
        <small>GX Budz is run by members of the <a className='newlink' href='https://spacebudz.io' target='_blank' rel="noreferrer">SpaceBudz</a> community on the <a className='newlink' href='https://cardano.org/' target='_blank' rel="noreferrer">Cardano</a> blockchain.</small>
      </div>
    </footer>
  )
}


export default Footer